import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditAbout({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setCred = (i, v) => {
    const creds = [...(value.credentials || [])];
    creds[i] = v;
    set("credentials", creds);
  };
  const addCred = () => set("credentials", [...(value.credentials || []), ""]);
  const removeCred = (i) => set("credentials", (value.credentials || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Sobre Mim">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="about-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="about-title-input" /></Field>
        <Field label="Bio (use linha em branco entre parágrafos)">
          <TextArea value={value.bio} onChange={(v) => set("bio", v)} rows={8} testId="about-bio-input" />
        </Field>
        <ImageUploadField label="Foto profissional" value={value.image} onChange={(v) => set("image", v)} testId="about-image" />

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Credenciais</span>
            <ListAddBtn onClick={addCred} label="Adicionar" testId="about-add-credential" />
          </div>
          <div className="space-y-3">
            {(value.credentials || []).map((c, i) => (
              <div key={i} data-testid={`about-credential-row-${i}`} className="flex items-center gap-3">
                <div className="flex-1"><TextInput value={c} onChange={(v) => setCred(i, v)} testId={`about-credential-${i}`} /></div>
                <ListRemoveBtn onClick={() => removeCred(i)} testId={`about-credential-remove-${i}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
